/* eslint-disable @nx/enforce-module-boundaries */
import { FeatureFlags } from '@aibees/elephant/types/feature-flags';
import { useAuthContext } from '@aibees/shared/auth';
import { UserRole } from '@aibees/shared/definition';
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';

export function useIsPeopleLookalikeEnabled() {
  const { user } = useAuthContext();

  const hasPeopleLookalikeRole = user?.roles?.includes(
    UserRole.ElPrsnLooklikeSrch
  );

  const isPeopleLookalikeEnabled = useFeatureFlagsContext().isFeatureEnabled(
    FeatureFlags.PEOPLE_LOOKALIKE_SEARCH
  );

  return isPeopleLookalikeEnabled || hasPeopleLookalikeRole;
}
